import { render, staticRenderFns } from "./phoneLoadPassword.vue?vue&type=template&id=c090c508&scoped=true&"
import script from "./phoneLoadPassword.vue?vue&type=script&lang=js&"
export * from "./phoneLoadPassword.vue?vue&type=script&lang=js&"
import style0 from "./phoneLoadPassword.vue?vue&type=style&index=0&id=c090c508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c090c508",
  null
  
)

export default component.exports